// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// //Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		// //Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		// scrollW();
		// window.addEventListener('scroll', function(){
		// 	scrollW();
		// })

		manageFormEvents();
	};
	//instagramAjaxFeed('zanzibaratx',6,'#gallery-instagram-images',380,'.instagram_gallery');

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function manageFormEvents(){
	
	const partySizeInput = document.getElementById('id_5_326');
	createDPFormEvents();

	if( partySizeInput ){

		partySizeInput.addEventListener('change' , (e) =>{
			let partySizeValue = e.target.value;

			if( partySizeValue > 20 ){
				createDPFormEvents(partySizeValue);
			}else{
				createDPFormEvents();
			}
		})

	}
	
}

function createDPFormEvents(partySize = 0){
	const dpForm = document.getElementById('id_6_326');

	if(dpForm){

		if(partySize > 20){

			$( "#id_6_326" ).datepicker('destroy');
	
			$('#id_6_326').datepicker({
				dateFormat: 'mm/dd/yy',
				onSelect: function(dateParam){
					disableTimeslot(dateParam)
				},
				beforeShowDay: function(date){
					var day = date.getDay();
					return [(day != 5 && day != 6)];
				}
			});
	
		}else{
	
			$( "#id_6_326" ).datepicker('destroy');
		
			$('#id_6_326').datepicker({
				dateFormat: 'mm/dd/yy',
				onSelect: function(dateParam){
					disableTimeslot(dateParam)
				}
			});
	
		}

	}
}

function disableTimeslot(dayNumber){

	const dateDay = new Date(dayNumber).getDay();
	const timeSelect = document.getElementById('id_7_326');

	if(timeSelect){
		
		//Monday - Thursday
		if( [1,2,3,4].includes( dateDay) ){
			let options = `	<option hidden> Desired Timeslot *</option>
							<option>---</option>
							<option value="4PM - 6PM"> 4PM - 6PM </option>
							<option value="5PM - 7PM"> 5PM - 7PM </option>
							<option value="6PM - 8PM"> 6PM - 8PM </option>
							<option value="7PM - 9PM"> 7PM - 9PM </option>
							<option value="8PM - 10PM"> 8PM - 10PM </option>
							`;
			$('#id_7_326').empty();
			$('#id_7_326').append(options);
		}

		//Friday - Saturday
		if( [5,6].includes( dateDay) ){
			let options = `	<option hidden> Desired Timeslot *</option>
							<option>---</option>
							<option value="12PM - 2PM"> 12PM - 2PM </option>
							<option value="1PM - 3PM"> 1PM - 3PM </option>
							<option value="2PM - 4PM"> 2PM - 4PM </option>
							<option value="3PM - 5PM"> 3PM - 5PM </option>
							<option value="4PM - 6PM"> 4PM - 6PM </option>
							<option value="5PM - 7PM"> 5PM - 7PM </option>
							<option value="6PM - 8PM"> 6PM - 8PM </option>
							<option value="7PM - 9PM"> 7PM - 9PM </option>
							<option value="8PM - 10PM"> 8PM - 10PM </option>
							<option value="9PM - 11PM"> 9PM - 11PM </option>
							<option value="10PM - 12PM"> 10PM - 12PM </option>
							`;
			$('#id_7_326').empty();
			$('#id_7_326').append(options);
		}
		
		//Sunday
		if( [0].includes( dateDay) ){
			let options = `	<option hidden> Desired Timeslot *</option>
							<option>---</option>
							<option value="12PM - 2PM"> 12PM - 2PM </option>
							<option value="1PM - 3PM"> 1PM - 3PM </option>
							<option value="2PM - 4PM"> 2PM - 4PM </option>
							<option value="3PM - 5PM"> 3PM - 5PM </option>
							<option value="4PM - 6PM"> 4PM - 6PM </option>
							<option value="5PM - 7PM"> 5PM - 7PM </option>
							<option value="6PM - 8PM"> 6PM - 8PM </option>
							<option value="7PM - 9PM"> 7PM - 9PM </option>
							<option value="8PM - 10PM"> 8PM - 10PM </option>
							`;
			$('#id_7_326').empty();
			$('#id_7_326').append(options);
		}
	}
	
}